import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Layout alternativo de las pantallas `/views/*` (legacy `Layouts2`): pantallas de planta pensadas para
 * celular o tablet, de a una por vez. A diferencia de `MainLayoutComponent` no tiene sidebar ni topbar:
 * cada pantalla trae su propio botón de salida. El feedback global (toasts) vive en la raíz de la app.
 */
@Component({
  selector: 'app-views-layout',
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <main class="views-layout">
      <router-outlet />
    </main>
  `,
  styleUrl: './views-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewsLayoutComponent {}
